import CustomSelect from "app/common/components/CustomSelect";
import { allCountries } from "app/common/data/countries";
import { getCountryName } from "app/common/util/Helpers";


const CustomCountrySelect = props => {

    return  <CustomSelect
                data={allCountries}
                searchable={true}
                placeholder=" Select Country"
                formatValue={item => item?.iso ?? item}
                minLength={2}
                maxLength={2}
                pattern="[A-Z]{3}"
                formatSelected={item => !item ? 
                                            <span className="text-grey-3 dark:text-dark-2">{props.placeholder || "Select Country"}</span> 
                                            : <>
                                                <img
                                                    src={`/assets/media/svg/flag/${(item.code ?? item)?.substr(0, 2)?.toLowerCase() }.svg`}
                                                    className="mr-3 inline-block w-5 rounded-full"
                                                    alt={item?.code ?? item}
                                                />{item.name ?? getCountryName(item)}
                                            </>
                                }
                formatOpt={item => <>
                                        <img
                                            src={`/assets/media/svg/flag/${item.code?.toLowerCase()}.svg`}
                                            className="mr-3 inline-block w-5 rounded-full"
                                            alt={item?.iso}
                                        />{item.name}
                                    </>}
                {...props}
            /> 
}

export default CustomCountrySelect;